<template>
    <div class="user-selects-wpr">
        <i title="清空" class="el-icon-error remove-btn" @click="clearInput"></i>
        <slot></slot>
        <el-select 
                size="medium"
                class="user-selects"
                v-model="selectValue"
                :multiple="multiple"
                filterable
                remote
                ref="select"
                @change="change"
                popper-class="user-selects-list"
                :disabled="disabled"
                :placeholder="holder"
                :remote-method="remoteMethod"
                :loading="loading">
            <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.lastName"
                    :value="item.id">
                <span class="user-name">{{ leftFormater(item) }}</span>
                <span class="user-dept">{{ rightFormater(item) }}</span>
            </el-option>
        </el-select>
    </div>
</template>

<script type="text/javascript">
    import axios from 'axios'
    import _ from 'underscore'
    export default {
        props: {
            holder: {
                type: String,
                default: '请输入工号或者姓名'
            },
            disabled: {
                type: Boolean,
                default: false
            },
            searchUrl: {
                type: String,
                default: '/orgTree/user/search.api'
            },
            index: {
                type: Number,
                default: null
            },
            allowEmail: {
                type: Boolean,
                default: false
            },
            value: [String, Number],
            multiple: {
                type: Boolean,
                default: true
            },
            selected: this.multiple ? [] : {},
            leftFormater: {
                type: Function,
                default (obj) {
                    return obj.lastName || obj.name
                }
            },
            cacheOptions: {
                type: Array,
                default () {
                    return []
                }
            },
            rightFormater: {
                type: Function,
                default (obj) {
                    let depNames = []
                    obj.dept1Name && depNames.push(obj.dept1Name)
                    obj.dept2Name && depNames.push(obj.dept2Name)
                    obj.dept3Name && depNames.push(obj.dept3Name)
                    return depNames.join('->')
                }
            }
        },
        data () {
            return {
                options: [],
                selectedList: [],
                selectValue: this.multiple ? [] : '',
                loading: false
            }
        },
        mounted () {
            this.cacheOptionsProcess(this.cacheOptions)
        },
        watch: {
            selectValue: function () {
                this.$emit('change', this.multiple ? this.selectValue.join(',') : this.selectValue, this.index)
                this.$emit('input', this.selectValue instanceof Array ? this.selectValue.join(',') : this.selectValue)
            }
        },
        methods: {
            update (val) {
                this.cacheOptionsProcess(this.cacheOptions)
            },
            isEmail (str) {
                return str.indexOf('@') > 0
            },
            reset () {
                this.selectValue = this.multiple ? [] : ''
                this.options = []
            },
            remoteMethod (query) {
                if (query !== '') {
                    if (this.ajax) {
                        this.source.cancel('取消未返回的请求')
                    }
                    this.loading = true
                    let CancelToken = axios.CancelToken
                    this.source = CancelToken.source()
                    this.ajax = axios.get(this.searchUrl, {
                        params: {queryKey: query},
                        cancelToken: this.source.token,
                        'X-loadingOff': true
                    }).then((res) => {
                        this.ajax = null
                        this.loading = false
                        this.options = res.result.list
                        if (this.allowEmail && this.isEmail(query)) {
                            this.options.unshift({
                                id: query,
                                email: query,
                                lastName: query,
                                dept1Name: '',
                                dept2Name: '',
                                dept3Name: ''
                            })
                        }
                    }).catch(e => {})
                } else {
                    this.options = []
                }
            },
            clearInput () {
                this.selectValue = this.multiple ? [] : ''
            },
            cacheOptionsProcess (cacheOptions) {
                if (cacheOptions.length) {
                    let cacheOptionArr = []
                    cacheOptions.forEach(item => {
                        cacheOptionArr.push({
                            value: typeof this.value === 'string' ? String(item.id) : item.id,
                            currentLabel: item.name
                        })
                    })
                    this.$refs.select.$data.cachedOptions = cacheOptionArr
                    this.selectValue = this.multiple ? (this.value.length ? this.value.split(',') : []) : this.value
                }
            },
            setDefaultValueLater (id, name) {
                console.log('setDefault user-select')
                let arr
                if (id instanceof Array) {
                    arr = id.map((item, index) => {
                        return {
                            value: String(item),
                            currentLabel: name[index]
                        }
                    })
                    this.$refs.select.$data.cachedOptions = arr
                } else {
                    let ids = String(id).split(','),
                        names = name.indexOf(',') === -1 ? name.split('，') : name.split(',')
                    arr = []
                    ids.forEach((item, index) => {
                        arr.push({
                            value: item,
                            currentLabel: names[index]
                        })
                    })
                    id = this.multiple ? ids : id
                    this.$refs.select.$data.cachedOptions = arr
                }
                this.selectValue = id
            },
            setDefaultValue (data, ids, conf = {valueName: 'id', textName: 'name'}) {
                let cacheOptions = []
                this.$refs.select.$data.cachedOptions = ''
                ids = String(ids)
                if (ids !== '') {
                    data.forEach(item => {
                        cacheOptions.push({
                            value: String(item[conf.valueName]),
                            currentLabel: item[conf.textName]
                        })
                    })
                    this.$refs.select.$data.cachedOptions = cacheOptions
                }
                this.selectValue = ids.length ? ids.split(',') : (this.multiple ? [] : '')
            },
            addUsers (data, conf = {valueName: 'id', textName: 'name'}) {
                let cacheOptions = [], ids = [], curIds = _.pluck(this.getSelected(), 'id')
                data.forEach(item => {
                    if (curIds.indexOf(String(item[conf.valueName])) === -1) {
                        cacheOptions.push({
                            value: String(item[conf.valueName]),
                            currentLabel: item[conf.textName]
                        })
                        ids.push(String(item[conf.valueName]))
                    }
                })
                this.$refs.select.$data.cachedOptions = cacheOptions.concat(this.$refs.select.$data.cachedOptions)
                if (_.isArray(this.selectValue)) {
                    this.selectValue = this.selectValue.concat(ids)
                } else {
                    this.selectValue = this.selectValue.length === 0 ? ids.join('') : (this.selectValue + ',' + ids.join(''))
                }
            },
            getSelected () {
                let result = []
                this.$refs.select.$data.selected.forEach(item => {
                    result.push({
                        id: item.value,
                        name: item.currentLabel
                    })
                })
                return result
            },
            change (value) {
                this.$refs.select.query = ''
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
    .user-selects-wpr {
        position : relative;
        .remove-btn {
            position  : absolute;
            right     : 10px;
            top       : 13px;
            z-index   : 1;
            font-size : 12px;
            color     : #ddd;
            cursor    : pointer;
            &:hover {
                color : #20a0ff;
            }
        }
    }

    .user-selects {
        width : 100%;
    }

    .user-selects-list {
        .user-name {
            float : left;
        }
        .user-dept {
            margin    : 1px 25px 0 10px;
            float     : right;
            font-size : 12px;
            color     : #bbb;
        }
    }
</style>



// WEBPACK FOOTER //
// searchDownList.vue?2ae54444